export const ALLOWED_COUNTRY_PREFIXES: readonly number[] = [
  49, // Deutschland
  376, // Andorra
  32, // Belgien
  55, // Brasilien
  359, // Bulgarien
  45, // Dänemark
  372, // Estland
  358, // Finnland
  33, // Frankreich
  30, // Griechenland
  91, // Indien
  353, // Irland
  39, // Italien
  385, // Kroatien
  371, // Lettland
  423, // Liechtenstein
  370, // Litauen
  352, // Luxemburg
  356, // Malta
  377, // Monaco
  31, // Niederlande
  47, // Norwegen
  43, // Österreich
  48, // Polen
  351, // Portugal
  40, // Rumänien
  378, // San Marino
  46, // Schweden
  41, // Schweiz
  381, // Serbien
  386, // Slowenien
  421, // Slowakei
  34, // Spanien
  420, // Tschechien
  36, // Ungarn
  44, // Vereinigtes Königreich
  357 // Zypern
]

// Sort by value (descending) – avoids partial matches in regex alternation
const _prefixAlternation = [...ALLOWED_COUNTRY_PREFIXES].sort((a, b) => b - a).join('|')

const VALID_PHONE_REGEX = new RegExp(
  String.raw`^(\+|00)(${_prefixAlternation})\d{4,30}\d$`
)

export function cleanPhoneNumber(phoneNumber: string): string {
  return phoneNumber.replaceAll(/[^\d+]/g, '')
}

export function isPhoneNumberValid(phoneNumber: string): boolean {
  return VALID_PHONE_REGEX.test(phoneNumber)
}

/**
 * Entfernt alle führenden Nullen aus einer Rufnummer ohne Ländervorwahl.
 * Beispiel: 0012345 -> 12345, 0000 -> ''
 */
export function removeLeadingZeros(phoneNumberWithoutCountrycode: string): string {
  return phoneNumberWithoutCountrycode.replace(/^0+/, '')
}
